// src/services/users.js - Updated with correct paths
import api from './api';

/**
 * Approve user (Admin only)
 * IMPORTANT: Path is /auth/users/:id/approve (NOT /admin/users/:id/approve)
 */
export const approveUser = async (userId) => {
  try {
    console.log('Approving user:', userId);
    const response = await api.post(`/auth/users/${userId}/approve`);
    console.log('Approval response:', response.data);
    return response.data;
  } catch (error) {
    console.error('Approve user error:', error.response || error);
    const message = error.response?.data?.error || 
                   error.response?.data?.message || 
                   'Failed to approve user';
    throw new Error(message);
  }
};

/**
 * Reject user (Admin only)
 */
export const rejectUser = async (userId, reason) => {
  try {
    console.log('Rejecting user:', userId, 'Reason:', reason);
    const response = await api.post(`/auth/users/${userId}/reject`, { reason });
    console.log('Rejection response:', response.data);
    return response.data;
  } catch (error) {
    console.error('Reject user error:', error.response || error);
    const message = error.response?.data?.error || 
                   error.response?.data?.message || 
                   'Failed to reject user';
    throw new Error(message);
  }
};

/**
 * Bulk approve users (Admin only)
 */
export const bulkApproveUsers = async (userIds) => {
  try {
    const response = await api.post('/auth/users/bulk-approve', { userIds });
    return response.data;
  } catch (error) {
    const message = error.response?.data?.error || error.response?.data?.message || 'Failed to bulk approve users';
    throw new Error(message);
  }
};

/**
 * Get pending approvals (Admin only)
 */
export const getPendingApprovals = async (params = {}) => {
  try {
    console.log('Fetching pending approvals');
    const response = await api.get('/auth/users/pending/approvals', { params });
    console.log('Pending approvals response:', response.data);
    return response.data;
  } catch (error) {
    console.error('Get pending approvals error:', error.response || error);
    const message = error.response?.data?.error || 
                   error.response?.data?.message || 
                   'Failed to fetch pending approvals';
    throw new Error(message);
  }
};

/**
 * Get all users (Admin only)
 */
export const getUsers = async (params = {}) => {
  try {
    const response = await api.get('/users', { params });
    return response.data;
  } catch (error) {
    const message = error.response?.data?.error || 
                   error.response?.data?.message || 
                   'Failed to fetch users';
    throw new Error(message);
  }
};

/**
 * Suspend a user (Admin only)
 */
export const suspendUser = async (userId) => {
  try {
    const response = await api.patch(`/users/${userId}/suspend`);
    return response.data;
  } catch (error) {
    console.error('Suspend user error:', error.response || error);
    const message = error.response?.data?.error || 
                   error.response?.data?.message || 
                   'Failed to suspend user';
    throw new Error(message);
  }
};

/**
 * Activate a suspended user (Admin only)
 */
export const activateUser = async (userId) => {
  try {
    const response = await api.patch(`/users/${userId}/activate`);
    return response.data;
  } catch (error) {
    console.error('Activate user error:', error.response || error);
    const message = error.response?.data?.error || 
                   error.response?.data?.message || 
                   'Failed to activate user';
    throw new Error(message);
  }
};

/**
 * Delete a user (Admin only)
 */
export const deleteUser = async (userId) => {
  try {
    const response = await api.delete(`/users/${userId}`);
    return response.data;
  } catch (error) {
    console.error('Delete user error:', error.response || error);
    const message = error.response?.data?.error || 
                   error.response?.data?.message || 
                   'Failed to delete user';
    throw new Error(message);
  }
};

/**
 * Get all radiologists (Any authenticated user)
 * For radiologist assignment dropdowns
 */
export const getRadiologists = async (params = {}) => {
  try {
    const response = await api.get('/users/radiologists', { params });
    return response.data;
  } catch (error) {
    const message = error.response?.data?.error || 
                   error.response?.data?.message || 
                   'Failed to fetch radiologists';
    throw new Error(message);
  }
};

export default {
  approveUser,
  rejectUser,
  getPendingApprovals,
  getUsers,
  getRadiologists,
  suspendUser,
  activateUser,
  deleteUser,
};